var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.windowResize.width < 1024)?[_c('Camera',{staticClass:"mb-3",attrs:{"openWindow":_vm.openWindow}}),_c('FilePicker')]:[_c('FilePickerDesktop',{attrs:{"openWindow":_vm.openWindow}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }